import { registerRoutingKey } from "Common/routingUtils";
import locale from "./routesMap.locale";
export default {
    SUMMARY_REPORT_DETAILS: registerRoutingKey("SUMMARY_REPORT_DETAILS")
};
const AREA_TITLE = locale.SUMMARY_REPORT_DETAILS;
export { AREA_TITLE };
